import { queryClient } from "@/utils/queryClient";
import { DASHBOARD_SERVICE_KEYS } from "./dashboard/keys";
import { RELATIONS_SERIVCE_KEYS } from "./relations/keys";

/**
 * Every list that shows a balance, refreshed together.
 *
 * A debt is derived from orders and payments, so the moment either changes,
 * the buyer and seller lists, the relation detail and the dashboard's debt
 * figures are all stale. They're separate queries, and forgetting one leaves a
 * number on screen that quietly disagrees with the rest of the page.
 *
 * Call it from every mutation that can move `current_debt` or
 * `sys_current_debt`: creating or acting on a payment, and creating, editing
 * or refunding an order.
 */
export const invalidateDebtQueries = () => {
	const keys = [
		RELATIONS_SERIVCE_KEYS.useGetRelations(),
		RELATIONS_SERIVCE_KEYS.useGetAggregatedSellers(),
		RELATIONS_SERIVCE_KEYS.useRelation(),
		RELATIONS_SERIVCE_KEYS.useRelationTransactions(),
		// platform debt in the header, and debts_to_pay / debts_to_receive
		DASHBOARD_SERVICE_KEYS.useGetDashboardCommon(),
		DASHBOARD_SERVICE_KEYS.useGetDashboardOverview(),
	];

	for (const queryKey of keys) {
		queryClient.invalidateQueries({ queryKey });
	}
};
